import {Header} from "../components/Header";
import {Footer} from "../components/Footer";
import {RoadCompensationContent} from "../components/contentComponents/RoadCompensationContent";
import {RoadCompensationOneMonthContent} from "../components/contentComponents/RoadCompensationOneMonthContent";
import {useParams} from "react-router-dom";

export function RoadCompensationOneMonth() {
    const { monthReportId } = useParams();
    return (
        <div>
            <Header></Header>
            <RoadCompensationOneMonthContent monthReportId={monthReportId} ></RoadCompensationOneMonthContent>
            <Footer></Footer>
        </div>
    )
}
